import React from 'react'

import Select from 'react-select'
import { Item, Input } from '../../ListItem'

import { Label, ButtonBackground, Button } from './styles'

function FormLabel (props){
  return (
    <Label center={ props.center }>{ props.children }</Label>
  )
}

function FormInput (props){
  return (
    <Item width={ props.width }><Input name={ props.name } type={ props.type } placeholder={ props.placeholder } mask={ props.mask } center={ props.center } onChange={ props.onChange } value={ props.value } /></Item>
  )
}

function FormButton (props){
  return (
    <>
      <ButtonBackground/><Button onClick={ props.onClick }>{ props.children }</Button>
    </>
  )
}

//Stylings for react-select
const customStyles = {
  option: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    fontFamily: 'Barthowheel-Regular',
    color: state.isFocused && !state.isSelected ? '#054b82' : '#FFF',
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    '& input': { fontFamily: 'Barthowheel-Regular !important' }
  }),
  input: (provided, state) => ({
    ...provided,
    fontSize: '1em',
    fontFamily: 'Barthowheel-Regular !important',
    color: '#FFF'
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    fontSize: '1em',
    fontFamily: 'Barthowheel-Regular',
    color: '#FFF'
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#FFF'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#FFF'
  }),
  control: (provided, state) => ({
    ...provided,
    padding: 0,
    margin: 0,

    borderRadius: 0,
    border: 'none',
    outline: 'none',

    fontSize: '1em',
    fontFamily: 'Barthowheel-Regular',

    // color: state.isFocused ? '#054b82' : '#FFF',
    // background: state.isFocused ? 'rgba(219, 239, 245, 1)' : 'rgba(5, 75, 130, 1)',
    background: 'rgba(5, 75, 130, 1)',
    clipPath: 'polygon(0% 0%,100% 0%,97% 100%,2% 100%)'
  }),
  menu: (provided, state) => {
    return {
      ...provided,
      background: 'rgba(5, 75, 130, 1)',
      padding: 0,

      borderRadius: 0,
      border: 'none',
      outline: 'none',
      zIndex: 10
    }
  },
  singleValue: (provided, state) => {
    return { 
      ...provided,
      padding: 0,
      margin: 0,

      borderRadius: 0,
      border: 'none',
      outline: 'none',

      color: '#FFF',
      fontFamily: 'Barthowheel-Regular',
      background: 'rgba(5, 75, 130, 1)'
    };
  }
}

function FormSelect (props){
  return (
    <Select 
      styles={customStyles} 
      isSearchable={ props.isSearchable } 
      options={ props.options } 
      defaultValue={ props.defaultValue }
      onChange={ props.onChange }/>
  )
}

export { FormInput, FormLabel, FormButton, FormSelect }
